import { render } from "./SystemCsvTranslationView.vue?vue&type=template&id=67a80bcf&scoped=true&ts=true"
import script from "./SystemCsvTranslationView.vue?vue&type=script&lang=ts"
export * from "./SystemCsvTranslationView.vue?vue&type=script&lang=ts"

import "./SystemCsvTranslationView.vue?vue&type=style&index=0&id=67a80bcf&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a80bcf"]])

export default __exports__